import React from 'react';

// Phones get one question per screen and the fixed app-like layout; same breakpoint as the CSS
const PHONE_QUERY = '(max-width: 768px)';

export default function usePhoneLayout() {
    const matches = () => typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches;
    const [isPhone, setIsPhone] = React.useState(matches);
    React.useEffect(() => {
        if (typeof window.matchMedia !== 'function') return;
        const query = window.matchMedia(PHONE_QUERY);
        const update = () => setIsPhone(query.matches);
        query.addEventListener('change', update);
        return () => query.removeEventListener('change', update);
    }, []);
    return isPhone;
}
